window.LoopTranslations = {
  PT: {
    // Dogs section
    dogs: {
      yourDogs: "Os meus cães",
      addNewDog: "Adicionar novo cão",
      name: "Nome",
      gender: "Género",
      lifeStage: "Fase da vida",
      weight: "Peso",
      male: "Macho",
      female: "Fêmea",
      puppy: "Cachorro",
      adult: "Adulto",
      senior: "Sénior",
      save: "Guardar",
      deleteProfile: "Apagar Perfil",
      cancel: "Cancelar",
      editDog: "Editar cão",
      deleteDogConfirmation: "Tem a certeza que quer apagar este perfil?",
      deleteDogWarning: "Depois de apagar, não poderá recuperar o perfil.",
      deleteDogNote:
        "Apagar o perfil do seu cão não elimina o plano. Para isso, clique no botão lateral 'Gerir encomendas'",
      thisPlanIsFor: "Este plano é para:",
      enterDogName: "Inserir nome do cão",
      enterDogWeight: "Inserir peso do cão",
      forDogs: "Para %s",
      articleMale: "o",
      articleFemale: "a",
      nameSeparator: "e",
      saveError: "Não foi possível guardar. Tente novamente.",
      loadError: "Não foi possível carregar os seus cães.",
      noDogs: "Ainda não tem cães adicionados.",
      requiredFields: "Preencha: %s.",
      sessionExpired: "A sua sessão expirou. Volte a iniciar sessão.",
      duplicateName: "Já tem um cão com este nome. Escolha outro nome.",
    },

    // UI elements
    ui: {
      see: "Ver",
      close: "Fechar",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Apagar",
      confirm: "Confirmar",
      loading: "A carregar...",
      retry: "Tentar novamente",
      error: "Erro",
      success: "Sucesso",
      update: "Atualizar",
      seeMore: "Ver mais",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Saber mais",
      close: "Fechar",
      earnCredit: "Ganhe crédito em cada encomenda:",
      earnCreditDesc: "Ganhe crédito a cada encomenda e troque-o por produtos.",
      expiry: "Expiração:",
      expiryDesc: "O crédito expira após 45 dias sem encomendas.",
      expiresIn: "Expira em %d dias",
      expiresInOne: "Expira em 1 dia",
      expiresInToday: "Expira hoje",
      expired: "Expirado",
      addProductWithWallet: "Adicionar produto com Wallet",
      productAddedSuccess: "Produto adicionado com sucesso!",
      productAddedError: "Erro ao adicionar produto. Tente novamente.",
      insufficientBalance: "Saldo insuficiente na Wallet",
      addProductSuccess: "Produto adicionado à próxima encomenda",
      youHaveCredit: "Tem %s€",
      notEnoughCredit: "Não tem crédito suficiente. Tem %s€",
      cantUseForSubscriptions: "Não pode usar crédito para subscrições",
      reactivateToUseWallet:
        "Reativar subscrição para usar o crédito da Wallet",
      reactivateDesc:
        "Depois de reativar poderá trocar o seu crédito por produtos.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Entregue todos os meses",
      lastOrderCharged: "A última encomenda foi cobrada em %s",
      quantity: "Quantidade: %d",
      processingInfo:
        "Estamos a processar a sua encomenda. O estado será atualizado automaticamente dentro de instantes.",
      processingDelayed:
        "O processamento da sua encomenda está a demorar mais tempo do que o habitual. Consulte o estado da encomenda mais tarde.",
    },

    shipping: {
      shippingCost: "%s€ entrega",
      freeShipping: "· Entrega gratuita",
    },

    // User actions
    user: {
      logout: "Encerrar sessão",
      login: "Iniciar sessão",
      profile: "Perfil",
      account: "Conta",
      subscription: "Subscrição",
      subscriptionCancelled: "O seu plano está cancelado",
      subscriptionTitle: "Subscrição de",
      reactivate: "Reativar",
      reactivateAndOrderNow: "Reativar e encomendar agora",
      reactivateConfirm:
        "Ao clicar no botão “OK”, irá reativar o seu plano e processaremos a sua encomenda.",
      subscriptionCancelledDesc:
        "Clique em “<strong>Reativar</strong>” para alterar ou remover produtos do seu plano. <br> Se pretende receber o seu plano agora, tal como está, clique em “<strong>Reativar e encomendar agora</strong>”.",
      editProduct: "Editar produto",
      removeProduct: "Remover",
      addedWithWallet: "Adicionado com wallet",
      confirmDelete:
        "Tem a certeza que deseja remover este produto do seu plano?",
      cannotRemoveLastProduct:
        "Este é o único produto da subscrição, por isso não pode ser removido.",
    },

    errors: {
      generic: "Ocorreu um erro. Por favor, tente novamente.",
      paymentError: {
        title: "Não foi possível processar o seu pagamento",
        description:
          "Atualize o método de pagamento para concluir a encomenda.\nSe estiver a usar um cartão de compra única, tente em alternativa um cartão de pagamento recorrente.",
        cta: "Atualizar método de pagamento",
        retry: "Tentar novamente",
      },
    },
  },

  IT: {
    // Dogs section
    dogs: {
      yourDogs: "I miei cani",
      addNewDog: "Aggiungi nuovo cane",
      name: "Nome",
      gender: "Sesso",
      lifeStage: "Fase della vita",
      weight: "Peso",
      male: "Maschio",
      female: "Femmina",
      puppy: "Cucciolo",
      adult: "Adulto",
      senior: "Senior",
      save: "Salva",
      deleteProfile: "Elimina Profilo",
      cancel: "Annulla",
      editDog: "Modifica cane",
      deleteDogConfirmation: "Sei sicuro di voler eliminare questo profilo?",
      deleteDogWarning:
        "Dopo l'eliminazione, non potrai recuperare il profilo.",
      deleteDogNote:
        "Eliminare il profilo del tuo cane non elimina il piano. Per farlo, clicca sul pulsante laterale 'Gestisci ordini'",
      thisPlanIsFor: "Questo piano è per:",
      enterDogName: "Inserisci nome del cane",
      enterDogWeight: "Inserisci peso del cane",
      forDogs: "Per %s",
      articleMale: "",
      articleFemale: "",
      nameSeparator: "e",
      saveError: "Non è stato possibile salvare. Riprova.",
      loadError: "Non è stato possibile caricare i tuoi cani.",
      noDogs: "Non hai ancora aggiunto cani.",
      requiredFields: "Compila: %s.",
      sessionExpired: "La tua sessione è scaduta. Accedi di nuovo.",
      duplicateName: "Hai già un cane con questo nome. Scegli un altro nome.",
    },

    // UI elements
    ui: {
      see: "Vedi",
      close: "Chiudi",
      cancel: "Annulla",
      save: "Salva",
      edit: "Modifica",
      delete: "Elimina",
      confirm: "Conferma",
      loading: "Caricamento...",
      retry: "Riprova",
      error: "Errore",
      success: "Successo",
      update: "Aggiorna",
      seeMore: "Vedi di più",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Scopri di più",
      close: "Chiudi",
      earnCredit: "Guadagna credito ad ogni ordine:",
      earnCreditDesc:
        "Guadagna credito con ogni ordine e riscattalo per i prodotti.",
      expiry: "Scadenza:",
      expiryDesc: "Il credito scade dopo 45 giorni senza ordini.",
      expiresIn: "Scade tra %d giorni",
      expiresInOne: "Scade tra 1 giorno",
      expiresInToday: "Scade oggi",
      expired: "Scaduto",
      addProductWithWallet: "Aggiungi prodotto con Wallet",
      productAddedSuccess: "Prodotto aggiunto con successo!",
      productAddedError: "Errore nell'aggiunta del prodotto. Riprova.",
      insufficientBalance: "Saldo insufficiente nel Wallet",
      addProductSuccess: "Prodotto aggiunto al prossimo ordine",
      youHaveCredit: "Hai %s€",
      notEnoughCredit: "Non hai abbastanza credito. Hai %s€",
      cantUseForSubscriptions: "Non puoi usare il credito per gli abbonamenti",
      reactivateToUseWallet:
        "Riattiva l'abbonamento per usare il credito della Wallet",
      reactivateDesc:
        "Dopo la riattivazione potrai scambiare il tuo credito con prodotti.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Consegnato ogni mese",
      lastOrderCharged: "L'ultimo ordine è stato addebitato il %s",
      quantity: "Quantità: %d",
      processingInfo:
        "Stiamo elaborando il tuo ordine. Lo stato si aggiornerà automaticamente tra pochi istanti.",
      processingDelayed:
        "L'elaborazione del tuo ordine sta richiedendo più tempo del solito. Controlla lo stato dell'ordine più tardi.",
    },

    shipping: {
      shippingCost: "%s€ spedizione",
      freeShipping: "· Spedizione gratuita",
    },

    // User actions
    user: {
      logout: "Esci",
      login: "Accedi",
      profile: "Profilo",
      account: "Account",
      subscription: "Abbonamento",
      subscriptionCancelled: "Il tuo piano è stato annullato",
      subscriptionTitle: "Abbonamento di",
      reactivate: "Riattiva",
      reactivateAndOrderNow: "Riattiva e ordina ora",
      reactivateConfirm:
        "Cliccando su “OK”, riattiverai il tuo piano e processeremo il tuo ordine.",
      subscriptionCancelledDesc:
        "Fai clic su “<strong>Riattiva</strong>” per modificare o rimuovere prodotti dal tuo piano. <br> Se vuoi ricevere il tuo piano così com’è e ordinare subito, fai clic su “<strong>Riattiva e ordina ora</strong>”.",
      editProduct: "Modifica prodotto",
      removeProduct: "Rimuovi",
      addedWithWallet: "Aggiunto con wallet",
      confirmDelete:
        "Sei sicuro di voler rimuovere questo prodotto dal tuo piano?",
      cannotRemoveLastProduct:
        "Questo è l'unico prodotto dell'abbonamento, per cui non può essere rimosso.",
    },

    errors: {
      generic: "Si è verificato un errore. Riprova.",
      paymentError: {
        title: "No hemos podido procesar tu pago",
        description:
          "Aggiorna il metodo di pagamento per completare il tuo ordine.\nSe stai utilizzando una carta per pagamenti una tantum, prova con una carta che supporti pagamenti ricorrenti.",
        cta: "Aggiorna metodo di pagamento",
        retry: "Riprova",
      },
    },
  },

  ES: {
    // Dogs section
    dogs: {
      yourDogs: "Mis perros",
      addNewDog: "Añadir nuevo perro",
      name: "Nombre",
      gender: "Género",
      lifeStage: "Etapa de vida",
      weight: "Peso",
      male: "Macho",
      female: "Hembra",
      puppy: "Cachorro",
      adult: "Adulto",
      senior: "Senior",
      save: "Guardar",
      deleteProfile: "Eliminar Perfil",
      cancel: "Cancelar",
      editDog: "Editar perro",
      deleteDogConfirmation:
        "¿Estás seguro de que quieres eliminar este perfil?",
      deleteDogWarning: "Después de eliminar, no podrás recuperar el perfil.",
      deleteDogNote:
        "Eliminar el perfil de tu perro no elimina el plan. Para eso, haz clic en el botón lateral 'Gestionar pedidos'",
      thisPlanIsFor: "Este plan es para:",
      enterDogName: "Introducir nombre del perro",
      enterDogWeight: "Introducir peso del perro",
      forDogs: "Para %s",
      articleMale: "",
      articleFemale: "",
      nameSeparator: "y",
      saveError: "No se ha podido guardar. Inténtalo de nuevo.",
      loadError: "No se han podido cargar tus perros.",
      noDogs: "Aún no tienes perros añadidos.",
      requiredFields: "Rellena: %s.",
      sessionExpired: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
      duplicateName: "Ya tienes un perro con este nombre. Elige otro nombre.",
    },

    // UI elements
    ui: {
      see: "Ver",
      close: "Cerrar",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      confirm: "Confirmar",
      loading: "Cargando...",
      retry: "Intentar de nuevo",
      error: "Error",
      success: "Éxito",
      update: "Actualizar",
      seeMore: "Ver más",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Saber más",
      close: "Cerrar",
      earnCredit: "Gana crédito en cada pedido:",
      earnCreditDesc: "Gana crédito con cada pedido y canjéalo por productos.",
      expiry: "Caducidad:",
      expiryDesc: "El crédito caduca tras 60 días sin pedir.",
      expiresIn: "Crédito caduca en %d días",
      expiresInOne: "Crédito caduca en 1 día",
      expiresInToday: "Crédito caduca hoy",
      expired: "Caducado",
      addProductWithWallet: "Usar crédito de la wallet",
      productAddedSuccess: "¡Producto añadido con éxito!",
      productAddedError: "Error al añadir producto. Inténtalo de nuevo.",
      insufficientBalance: "Saldo insuficiente en Wallet",
      addProductSuccess: "Producto añadido al próximo pedido",
      youHaveCredit: "Tienes %s€ en tu wallet",
      notEnoughCredit: "No tienes suficiente crédito. Tienes %s€ en tu wallet",
      cantUseForSubscriptions: "No puedes usar crédito para suscripciones",
      reactivateToUseWallet:
        "Reactivar suscripción para usar el crédito de la Wallet",
      reactivateDesc:
        "Después de reactivar podrás intercambiar tu crédito por productos.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Entregado cada mes",
      lastOrderCharged: "El último pedido se cobró el %s",
      quantity: "Cantidad: %d",
      processingInfo:
        "Estamos procesando tu pedido. El estado se actualizará automáticamente en unos instantes.",
      processingDelayed:
        "El procesamiento de tu pedido está tardando más de lo habitual. Consulta el estado del pedido más tarde.",
      // WEB-152: order history drawer (pending Sofia approval)
      downloadInvoice: "Descargar la factura",
      invoiceNotAvailable: "La factura de este pedido aún no está disponible.",
      invoiceError: "No se ha podido descargar la factura. Inténtalo de nuevo más tarde.",
    },

    shipping: {
      shippingCost: "%s€ entrega",
      freeShipping: "· Entrega gratuita",
    },

    // User actions
    user: {
      logout: "Cerrar sesión",
      login: "Iniciar sesión",
      profile: "Perfil",
      account: "Cuenta",
      subscription: "Suscripción",
      subscriptionCancelled: "Tu plan está cancelado",
      subscriptionTitle: "Suscripción de",
      reactivate: "Reactivar",
      reactivateAndOrderNow: "Reactivar y pedir ahora",
      reactivateConfirm:
        "Al hacer clic en “OK”, reactivarás tu plan y tramitaremos tu pedido.",
      subscriptionCancelledDesc:
        "Haz clic en “<strong>Reactivar</strong>” para editar o eliminar productos de tu plan. <br> Si quieres recibir tu plan tal cual y pedir ahora, haz clic en “<strong>Reactivar y pedir ahora</strong>”.",
      editProduct: "Editar producto",
      removeProduct: "Eliminar",
      addedWithWallet: "Añadido con wallet",
      confirmDelete:
        "¿Estás seguro de que deseas eliminar este producto de tu plan?",
      cannotRemoveLastProduct:
        "Este es el único producto de la suscripción, por lo que no se puede eliminar.",
    },

    errors: {
      generic: "No pudimos procesar tu pago",
      paymentError: {
        title: "No hemos podido procesar tu pago",
        description:
          "Por favor, actualiza tu método de pago para completar tu pedido.\nSi estás utilizando una tarjeta de un solo uso, prueba con una tarjeta que permita pagos recurrentes.",
        cta: "Actualizar método de pago",
        retry: "Intentar de nuevo",
        byCategory: {
          CARD_EXPIRED: {
            title: "Tu tarjeta ha caducado",
            description: "Actualiza tu tarjeta para finalizar tu pedido.",
          },
          INCORRECT_CARD_NUMBER: {
            title: "El número de tu tarjeta no es válido",
            description: "Verifica los datos de tu tarjeta e inténtalo de nuevo.",
          },
          INSUFFICIENT_FUNDS: {
            title: "La tarjeta no tiene fondos",
            description: "Para finalizar tu pedido, actualiza tu tarjeta.",
          },
          INVALID_PAYMENT_METHOD: {
            title: "El método de pago no es válido",
            description:
              "Añade una nueva tarjeta para continuar. Si estás usando una tarjeta de un solo uso, prueba con una tarjeta de pago recurrente.",
          },
          CARD_TYPE_NOT_SUPPORTED: {
            title: "Esta tarjeta no admite pagos recurrentes",
            description:
              "Normalmente ocurre con tarjetas de un solo uso (temporales o virtuales). Prueba con una tarjeta física o, si necesitas una tarjeta temporal, elige una que permita pagos recurrentes.",
          },
          PAYMENT_METHOD_REVOKED: {
            title: "Tu método de pago ha sido eliminado",
            description:
              "Añade un nuevo método de pago para continuar. Si estás usando una tarjeta de un solo uso, prueba con una tarjeta de pago recurrente.",
          },
          FRAUD_SUSPECTED: {
            title: "No hemos podido confirmar el pago",
            description:
              "Prueba con otro método de pago.",
          },
          INVALID_ADDRESS: {
            title: "La dirección de facturación no coincide con la de tu tarjeta",
            description: "Verifica la dirección e inténtalo de nuevo.",
          },
          AUTHENTICATION_FAILED: {
            title: "No hemos podido confirmar la autenticación del pago",
            description: "Inténtalo de nuevo o utiliza otro método de pago.",
          },
          PAYPAL_AGREEMENT_CANCELLED: {
            title: "Tu acuerdo de PayPal ha sido cancelado",
            description: "Vuelve a asociar PayPal o añade otro método de pago.",
          },
          PAYPAL_AGREEMENT_INVALID: {
            title: "Tu acuerdo de PayPal no es válido",
            description: "Vuelve a asociar PayPal o añade otro método de pago.",
          },
          PAYPAL_GENERAL_ERROR: {
            title: "Se ha producido un error con PayPal",
            description: "Inténtalo de nuevo o utiliza otro método de pago.",
          },
          INVALID_CUSTOMER: {
            title: "No hemos podido validar tus datos",
            description: "Por favor, contacta con nuestro soporte.",
          },
          GENERIC_ERROR: {
            title: "No hemos podido procesar tu pago",
            description:
              "Actualiza tu tarjeta o prueba con otra para que podamos procesar tu pedido. Si estás usando una tarjeta de un solo uso, prueba con una tarjeta de pago recurrente.",
          },
          INVALID_GIFT_CARD_AMOUNT: {
            title: "El valor de la tarjeta regalo no es válido",
            description: "Utiliza otro método de pago.",
          },
          INSUFFICIENT_INVENTORY: {
            title: "No hay stock suficiente para el pedido",
            description: "Elimina el producto agotado para finalizar el pedido.",
          },
          NO_INVENTORY_LOCATION: {
            title: "No hemos podido localizar el stock para este pedido.",
            description: "Por favor, contacta con nuestro soporte.",
          },
          INVALID_CURRENCY: {
            title: "Se ha producido un error con la moneda del pago.",
            description:
              "Por favor, contacta con nuestro soporte para resolver esta situación.",
          },
          INVOICE_ALREADY_PAID: {
            title: "Este pedido ya ha sido pagado",
            description: "No es necesaria ninguna acción por tu parte.",
          },
          MERCHANT_ACCOUNT_ERROR: {
            title: "Se ha producido un error en el procesamiento del pago",
            description: "Por favor, contacta con nuestro soporte para resolver esta situación.",
          },
          GATEWAY_TEST_MODE_ERROR: {
            title: "Se ha producido un error en el procesamiento del pago",
            description: "Por favor, contacta con nuestro soporte para resolver esta situación.",
          },
          PAYMENT_PROVIDER_ERROR: {
            title: "Se ha producido un error en el procesamiento del pago",
            description: "Inténtalo de nuevo en unos segundos.",
          },
          PAYMENT_PROVIDER_NOT_ENABLED: {
            title: "Este método de pago no está disponible",
            description: "Utiliza otro método de pago.",
          },
          TRANSACTION_LIMIT_EXCEEDED: {
            title: "No hemos podido confirmar el pago",
            description: "Añade una nueva tarjeta para continuar. Si estás usando una tarjeta de un solo uso, prueba con una tarjeta de pago recurrente.",
          },
          TRANSIENT_ERROR: {
            title: "Se ha producido un error temporal al procesar el pago",
            description: "Inténtalo de nuevo en unos segundos.",
          },
          AMOUNT_OUT_OF_RANGE: {
            title: "El valor de la transacción no es válido",
            description: "Contacta con nuestro soporte.",
          },
        },
      },
    },
  },
};
